import gql from 'graphql-tag';

export const FETCH_ORGANIZATIONS_LIST = gql`
  query {
    organizationsDetails(
      userType: PATIENT
    ) {
        orgId
        name
      }
  }
`;

// Used to fetch default site logo (when organization isn't selected)
export const FETCH_SITE_LOGO = gql`
  query {
    organizationsDetails(
      levelCodes: ["SYSTEM"],
      userType: PATIENT
    ) {
        logo
        logoLabels {
          locale
          value
        }
      }
  }
`;
